import React from 'react'
import ExcelFile from '../components/ExcelFile'

const Momentos = () => {

    return(
        <div>
            <br/> 
            <ExcelFile />
            

        </div>
    )
}
export default Momentos